import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LabelType } from '../entities/label-type.entity';

@Component({
    standalone: true,
    selector: 'sh-label',
    templateUrl: './label.component.html',
    imports: [CommonModule]
})
export class ShLabelComponent {
    private readonly baseClass: string = 'sh-label';

    labelClass: string = this.baseClass;
    modifierClasses = '';

    @Input()
    set type(type: LabelType | undefined) {
        this.setLabelClass(type);
    }

    @Input() tooltip: string = '';

    private setLabelClass(type: LabelType | undefined): void {
        switch (type) {
            case LabelType.Default:
                this.labelClass = this.baseClass;
                break;
            case LabelType.Error:
                this.labelClass = `${this.baseClass}--error`;
                break;
            case LabelType.Warning:
                this.labelClass = `${this.baseClass}--warning`;
                break;
            case LabelType.Success:
                this.labelClass = `${this.baseClass}--success`;
                break;
            case LabelType.Update:
                this.labelClass = `${this.baseClass}--update`;
                break;
            default:
                this.labelClass = `${this.baseClass}`;
                break;
        }
    }

    @Input() set childComponentClasses(entries: string[]) {
        this.modifierClasses = this.modifierClasses + ' ' + entries.join(' ');
    }
}
